// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NativeTransfer
 */
export interface NativeTransfer {
    /**
     * 
     * @type {string}
     * @memberof NativeTransfer
     */
    fromUserAccount: string | null;
    /**
     * 
     * @type {string}
     * @memberof NativeTransfer
     */
    toUserAccount: string | null;
    /**
     * 
     * @type {number}
     * @memberof NativeTransfer
     */
    amount: number;
}

/**
 * Check if a given object implements the NativeTransfer interface.
 */
export function instanceOfNativeTransfer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromUserAccount" in value;
    isInstance = isInstance && "toUserAccount" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function NativeTransferFromJSON(json: any): NativeTransfer {
    return NativeTransferFromJSONTyped(json, false);
}

export function NativeTransferFromJSONTyped(json: any, ignoreDiscriminator: boolean): NativeTransfer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromUserAccount': json['fromUserAccount'],
        'toUserAccount': json['toUserAccount'],
        'amount': json['amount'],
    };
}

export function NativeTransferToJSON(value?: NativeTransfer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromUserAccount': value.fromUserAccount,
        'toUserAccount': value.toUserAccount,
        'amount': value.amount,
    };
}

